export enum TRACK_COLLECTION_TEMPO {
  SLOW = 'slow',
  MEDIUM = 'medium',
  FAST = 'fast',
}
